import styles from './styles/RewardComponent.module.scss'
import { defineMessage, FormattedMessage, useIntl } from 'react-intl'
import { useState } from 'react'
import cx from 'classnames'

export default function RewardComponent() {
  const [ready, setReady] = useState(false)
  const { formatMessage } = useIntl()
  return (
    <div className={cx(styles.container, { [styles.notVisible]: !ready })}>
      <span className={styles.imageContainer}>
        <img loading='lazy' src={`${window.staticPath}travel_dist/images/reward-readers-choice.png`}
          alt={formatMessage(defineMessage({ defaultMessage: 'Readers choice' }))}
          onLoad={() => setReady(true)}
        />
      </span>
      <div className={styles.description}>
        <FormattedMessage defaultMessage='BEST DIVE TRAVEL AGENCY' tagName='strong' />
        <FormattedMessage defaultMessage='Scuba Diving Magazine Readers Choice Award' tagName='em' />
        <FormattedMessage defaultMessage='Winners - 2022, 2023, 2024' tagName='strong' />
      </div>
    </div>
  )
}
